import { Component, OnInit, Input } from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'app-boleto-component',
  templateUrl: './boleto-component.component.html',
  styleUrls: ['./boleto-component.component.scss']
})
export class BoletoComponentComponent implements OnInit {

  @Input() transaction: object;
  @Input() plan: object;

  boletoUrl = false

  constructor() { }

  ngOnInit() {
    this.boletoUrl = this.transaction['boleto_url'] 
  }

  formatDate (dateInput) {
    return moment(dateInput).format('DD/MM/YYYY')
  }

  voltar () {
    window.history.back()
  }

}
